import { lang } from '@ott/l10n';
import { NON_NUMBER_PAT, NON_NUMBER_PAT_WITH_PLUS } from '@ott/transforms';

import applyPattern from '../helpers/applyPattern';

const RU_NUMBER_SYMBOLS = 12;
const INTERN_NUMBER_SYMBOLS = 17;

const phoneCodes = {
  de: '49',
  'en-gb': '44',
  'en-ie': '353',
  'en-us': '1',
  es: '34',
  pl: '48',
  ru: '7',
  'ru-kz': '7',
  kz: '7',
  'ru-ua': '380',
  'ru-by': '375',
  tr: '90',
  'uk-ua': '380',
  'ru-us': '7',
  'ru-uz': '998',
};

export const makePhoneNumberFormatter = (options = {}) => {
  let isTouched = false;

  return (value = '', previous = '', cursor = 0, props = {}) => {
    if (!value) {
      if (props.isFocused) {
        if (!isTouched) {
          isTouched = true;

          return {
            value: `+${phoneCodes[lang]}`,
            cursor: 2,
          };
        }

        if (options.internationalPhone) {
          if (previous === `+${phoneCodes[lang]}`) {
            return {
              value: '+',
              cursor: 1,
            };
          }

          return {
            value: '',
            cursor: 0,
          };
        }

        return {
          value: '+',
          cursor: 1,
        };
      }

      return {
        value: '',
        cursor: 0,
      };
    }

    let modifiedValue = value;
    let newCursor = cursor;

    if (options.internationalPhone) {
      if (modifiedValue.startsWith('8') || modifiedValue.startsWith('9')) {
        modifiedValue = `+7${modifiedValue.slice(1)}`;
        newCursor += 1;
      }

      if (modifiedValue.startsWith('7') && modifiedValue.length > RU_NUMBER_SYMBOLS) {
        modifiedValue = modifiedValue.slice(0, RU_NUMBER_SYMBOLS);
      }

      if (!modifiedValue.startsWith('+')) {
        modifiedValue = `+${modifiedValue}`;
      }

      if (modifiedValue.length > INTERN_NUMBER_SYMBOLS) {
        modifiedValue = modifiedValue.slice(0, INTERN_NUMBER_SYMBOLS);
      }

      return applyPattern(modifiedValue, newCursor, NON_NUMBER_PAT_WITH_PLUS, (patternValue) => {
        if (!patternValue) {
          return '';
        }
        if (patternValue.startsWith('+7')) {
          return '11 (111) 111-11-11';
        }
        if (!patternValue.startsWith('7') || patternValue.length > RU_NUMBER_SYMBOLS) {
          return '111111111111*';
        }

        return '11 (111) 111-11-11';
      });
    }

    return applyPattern(modifiedValue, newCursor, NON_NUMBER_PAT, (patternValue) => {
      if (!patternValue) {
        return '';
      }
      if (!patternValue.startsWith('7') || patternValue.length > 11) {
        return '+11111111111*';
      }

      return '+1 111 111 11 11';
    });
  };
};

export const phoneNumberFormatterMask = (value) => {
  if (value && value.startsWith(7) && value.length <= 11) {
    return '+7 XXX XXX XX XX';
  }

  return '+XXXXXXXXXXX';
};

const getRuNumberPattern = (v) => {
  if (!v) {
    return '';
  }
  if (v.charAt(0) === '7') {
    switch (v.length) {
      case 1:
        return '+1';
      case 2:
      case 3:
      case 4:
        return '+1 (111';
      case 5:
      case 6:
      case 7:
        return '+1 (111) 111';
      case 8:
      case 9:
      case 10:
        return '+1 (111) 111-111';
      case 11:
        return '+1 (111) 111-11-11';
      default:
        return '+1 *';
    }
  } else {
    return '+*';
  }
};

// eslint-disable-next-line no-unused-vars
export const phoneNumberRuFormatter = (value = '', previous = '', cursor = 0) => {
  return applyPattern(value, cursor, NON_NUMBER_PAT, getRuNumberPattern);
};

export const makeInternationalPhoneNumberFormatter = () =>
  makePhoneNumberFormatter({ internationalPhone: true });
